export default class DataLoaderError extends Error {
  constructor(message, downstreamError) {
    super(message);
    this.name = 'DataLoaderError';
    this.downstreamError = downstreamError;
  }
}
